export default "__VITE_ASSET__DkqSlvSP__"